// packages/ui-kit/src/people/StatusBadge.tsx
// C3F v18 — reference: design/system/components/people/StatusBadge.{jsx,prompt.md}
// Account status of a person. Not for operational states (shifts, tasks):
// those are TaskRow's vocabulary.
import { Badge, type BadgeTone } from "../primitives/Badge.js";

type UserStatus = "active" | "pending" | "disabled";

const toneFor: Record<UserStatus, BadgeTone> = {
  active: "success",
  // An account waiting for first sign-in is an invited one — `info`, not a
  // warning: nothing is wrong, someone just hasn't arrived yet.
  pending: "info",
  disabled: "neutral",
};

const labelFor: Record<UserStatus, string> = {
  active: "Attivo",
  pending: "Invitato",
  disabled: "Disattivato",
};

// The 6px dot repeats the state ink, solid (DS Badge `dot`). Passed as
// iconLeft because the dot lives with the badge, not with the text.
const dotCls: Record<UserStatus, string> = {
  active: "bg-success",
  pending: "bg-info",
  disabled: "bg-fg-muted",
};

export function StatusBadge({ status, label }: { status: UserStatus; label?: string }) {
  return (
    <Badge
      tone={toneFor[status]}
      variant="soft"
      size="sm"
      className="whitespace-nowrap"
      iconLeft={<span aria-hidden className={`h-1.5 w-1.5 rounded-full ${dotCls[status]}`} />}
    >
      {label ?? labelFor[status]}
    </Badge>
  );
}
